import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateProcedureModalComponent } from './modal/create-procedure-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProcedureService } from '../../services/procedure.service';
import { CreatePlansConsultationDto, GetAllPlansConsultationDto } from '../../dto/procedure.dto';
import { Specialty } from '../../dto/specialty.dto';
import { SpecialtyService } from '../../services/specialty.service';
import { addSpecialtyChangePricesModal, modalDate } from './modal/add-specialty-change-prices-modal.component';
import { takeUntil, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { detailsModal, DeleteInactiveActiveModalComponent } from './modal/delete-specialty-inactive-active-procedure-modal.component';

@Component({
  selector: 'app-procedure-plans',
  templateUrl: './procedure-plans.component.html',
  styleUrls: ['./procedure-plans.component.scss']
})
export class ProcedurePlansComponent implements OnInit {

    constructor( 
      private dialog: MatDialog,
      private service: ProcedureService,
      private getSpecialty: SpecialtyService,
      private snack: MatSnackBar,
    ) { }
    filter = [
      { name: 'Ativos', boolean: true },
      { name: 'Inativos', boolean: false },
    ];
    filterList: boolean = true;
    activeInfo: number | null = null; 
    procedureList: GetAllPlansConsultationDto[];
    specialtyList: Specialty[];
    specialtyFilteredList: Specialty[] = [];
    addSpecialtyList: Omit<Specialty, 'isActive'>[] = [];
    pcSpecialtyList: any[] = [];

    editProcedurePrice: boolean;
    editPriceValue: number;
    editProceduretransferAmmount: boolean;
    editTransferAmmountValue: number;

    specialtyForm = new FormControl([]);

    page: number = 1;
    pageSize: number = 10;
    totalItems: number = 0;
    
    ngOnInit(): void {
      this.filterProcedure();
      this.listAllSpecialty();
      this.getPcsRelationList();
    }
    trackById(index: number, item: any) {
      return item.id;
    }

    filterProcedure():void {
      this.getListProcedures(this.filterList, 1);
    }

    createProcedure(data: CreatePlansConsultationDto): Promise<any> {
      return new Promise ((res, error) => {
        this.service.createProcedure(data).subscribe({
          next: (data) => { 
            res ({ message: "Procedimento criado com sucesso.", status: 200, data});
          },
          error: (err) => {
            error ({ message: "Erro ao criar procedimento.", status: 500, err});
          }
        })
      })
    }

    showDetails(id: number):void {
      this.editProcedurePrice = false;
      this.editProceduretransferAmmount = false;
      this.addSpecialtyList = [];
      this.activeInfo = this.activeInfo === id ? null : id;
      this.specialtyForm.reset();
    }

    currentProcedure (id: number): void {
      const currentList = this.procedureList.find(i => i.id === id);
      const currentListSpecialty = currentList.specialties.map(s => s.id);
      const getSamePlanIdList = this.pcSpecialtyList
                                  .filter(i => i.planId === currentList.planId && i.id !== id)
                                  .flatMap(i => i.specialties.map(i => i.id));

      const allSpecialtyId = [...new Set([...currentListSpecialty, ...getSamePlanIdList])];

      const specialtyId = this.specialtyList.filter(s => !allSpecialtyId.includes(s.id));

      this.specialtyFilteredList = specialtyId;

    }
    
    modalDeleteSpecialty( procedureId: number, procedureName: string, specialtyId: number, specialtyName: string ): void{
      const data = {
        procedureName,
        specialtyName,
        deleteSpecialty: true
      };

      const dialog = this.openDeleteSpecialtyAndInactivateModal(data);
      dialog.componentInstance.response$.pipe(
        takeUntil(dialog.afterClosed()),
        tap((data) => {
          if(data === 'Confirm') {
            this.deleteSpecialtyFromPc(procedureId, { specialtyId });
          }
        })
      ).subscribe();
    }

    modalInactivateProcedure(procedureId: number, procedureName: string): void {
      const data = {
        procedureName,
        inactiveProcedure: true,
      };
      const dialog = this.openDeleteSpecialtyAndInactivateModal(data);
      dialog.componentInstance.response$.pipe(
        takeUntil(dialog.afterClosed()),
        tap((data) => {
          if(data === 'Confirm') {
            this.inactivateProcedure(procedureId);
            this.activeInfo = null;
          }
        })
      ).subscribe();
    }

    modalActiveProcedure(procedureId: number, procedureName: string): void {
      const data = {
        procedureName,
        activeProcedure: true,
      };
      const dialog = this.openDeleteSpecialtyAndInactivateModal(data);
      dialog.componentInstance.response$.pipe(
        takeUntil(dialog.afterClosed()),
        tap((data) => {
          if(data === 'Confirm') {
            this.activeProcedure(procedureId);
            this.activeInfo = null;
          }
        })
      ).subscribe();
    }

    openModalCreateProcedure(): void {
      this.activeInfo = null;
      const dialog = this.dialog.open(CreateProcedureModalComponent);
      dialog.afterClosed().subscribe({
        next: async (data) => {
          if (data) {
            const create = await this.createProcedure(data);
            if (create.status === 200){
              this.page = 1;
              this.getListProcedures(this.filterList, this.page);
              this.snack.open( create.message, 'OK', { duration: 3000 });
            } else {
              this.snack.open( create.message, 'OK',{ duration: 3000 });
            }
          }
        },
        error: (err) => console.log(err)
      })
    }

    addSpecialtyModal(procedureId: number, procedureName: string, planId: number){
      const arraySpecialtyId = this.specialtyForm.value;
      const specialtyList = this.specialtyList.filter(s => arraySpecialtyId.includes(s.id))
                                              .map(s => ({id: s.id, name: s.name}));
      const modalData = {
        addSpecialty: {
          isAddSpecialty: true,
          list: specialtyList
        },
        isEditProcedureValue: null
      }
      if(this.specialtyForm.value.length >= 1){
        const dialog = this.openConfirmationModal(procedureId, procedureName, modalData);
        dialog.componentInstance.response$.pipe(
          takeUntil(dialog.afterClosed()),
          tap((data) => {
            if( data === 'Confirm' ) {
              this.insertSpecialty(procedureId, this.specialtyForm.value, planId);
              this.specialtyForm.reset();
            }
          })).subscribe()
      }
    }

    editPricesModal(procedureId: number, procedureName: string, currentPrice: number): void {
      /**Se for editar o preço do procedimento */
      if (this.editPriceValue){
        if(this.editPriceValue === currentPrice){
          this.snack.open("Não é possível alterar o valor para o mesmo valor.", '', { duration: 3000 });
          return 
        }
        const modalData = {
          addSpecialty: null,
          isEditProcedureValue: {
            isPriceEdit: true,
            isTAmmountEdit: false,
            currentPrice,
            newPrice: this.editPriceValue
          }
        }
        const dialog = this.openConfirmationModal(procedureId, procedureName, modalData);
        dialog.componentInstance.response$.pipe(
          takeUntil(dialog.afterClosed()),
          tap((data) => {
            if( data === 'Confirm' ) {
              this.editPlansConsultation(procedureId, { price: this.editPriceValue });
              this.editProcedurePrice = false;
            }
          })).subscribe();
      }

      /**Se for editar o valor de repasse do procedimento */
      if (this.editTransferAmmountValue){
        if(this.editTransferAmmountValue === currentPrice){
          this.snack.open("Não é possível alterar o valor de repasse para o mesmo valor.", '', { duration: 3000 });
          return 
        }
        const modalData = {
          addSpecialty: null,
          isEditProcedureValue: {
            isPriceEdit: false,
            isTAmmountEdit: true,
            currentPrice,
            newPrice: this.editTransferAmmountValue
          }
        }
        const dialog = this.openConfirmationModal(procedureId, procedureName, modalData);
        dialog.componentInstance.response$.pipe(
          takeUntil(dialog.afterClosed()),
          tap((data) => {
            if( data === 'Confirm' ) {
              this.editPlansConsultation(procedureId, { tAmmount: this.editTransferAmmountValue });
              this.editProceduretransferAmmount = false;
            }
          })).subscribe();
      }
    }


    pageChange(event: PageEvent) {
      const newPage = event.pageIndex + 1; 
      this.activeInfo = null;
      this.page = newPage;
      this.getListProcedures(this.filterList, newPage);
    }

    private getListProcedures( isActive: boolean , page:number, id?: number,): void {
      const params = {
        isActive,
        page
      };
      this.totalItems = 0;
          

      this.service.getListProcedures(params).subscribe({
        next: (data) => { 
          this.procedureList = data.lista;
          this.totalItems = data.totalPage; 
        },
        error: (err) => console.log(err)
      })
    }

    private getProcedureById(isActive: boolean , page:number, planId: number): void {
      const params = {
        isActive,
        page
      };
      this.service.getProcedureById(planId, params).subscribe({
        next: data => {
          const findProcedureIndex = this.procedureList.findIndex(i => i.id === data.lista[0].id);
          if(findProcedureIndex !== -1){
            this.procedureList[findProcedureIndex] = {... data.lista[0]};
            this.currentProcedure(planId);
          }
        }
      })
    }

    private getPcsRelationList(): void {
      this.service.getPcsRelationList().subscribe({
        next: data => {
          this.pcSpecialtyList = data;
        }
      })
    }

    private listAllSpecialty(): void {
      this.getSpecialty.findAll().subscribe({
        next: (data) => {
          const filterInactive = data.list.filter(active => active.isActive)
          this.specialtyList = filterInactive;
        },
        error: (err) => console.log(err)
      });
    }

    private editPlansConsultation(planId: number, params: {price?:number, tAmmount?: number}): void {
      this.service.editPlansConsultation(planId, params).subscribe({
        next: data => {
          const item = this.procedureList.find(item => item.id === data.id);
          item.price = data.price;
          item.transferAmmount = data.transferAmmount;
          this.editPriceValue = 0;
          this.editTransferAmmountValue = 0;
        }
        ,
        error: err => console.log(err)
      })
    }

    private deleteSpecialtyFromPc(planId: number, params: { specialtyId: number }): void {
      this.service.deleteSpecialtyFromPc(planId, params).subscribe({
        next: data => {
          if(data.status === "success") {
            this.getProcedureById(this.filterList, this.page, planId);
            this.snack.open( "Especialidades foi removida com sucesso.", 'OK', { duration: 3000 });
            this.activeInfo = planId;
            this.getPcsRelationList();
          }
        },
        error: err => console.log(err)
      })
    }

    private insertSpecialty(id: number, specialtyId: number[], planId: number): void {
      const params = { id, specialtyId, planId };
      this.service.insertSpecialty(params).subscribe({
        next: (data) => { 
          this.getProcedureById(this.filterList, this.page, id);
          this.snack.open( "Especialidades adicionada com sucesso.", 'OK', { duration: 3000 });
          this.activeInfo = id;
          this.getPcsRelationList();
        },
        error: (err) => console.log(err)
      })
    }
    private openDeleteSpecialtyAndInactivateModal(data: detailsModal) {
      
      const dialog = this.dialog.open(DeleteInactiveActiveModalComponent, {
        data
      });
      
      return dialog;
    }
    private openConfirmationModal(id: number, name: string, obj: modalDate){
      const dialog = this.dialog.open(addSpecialtyChangePricesModal, {
        data: {
          procedure_id: id,
          procedure_name: name,
          obj
        }
      });
        
      return dialog
    }

    private inactivateProcedure(planId: number) {
      this.service.inactivateProcedure(planId).subscribe({
        next: data => { 
          if (data.status === "success"){
            this.snack.open(data.message, 'OK', { duration: 3000 });
            this.getListProcedures(true, 1);
            this.getPcsRelationList();
          }
        },
      })
    }

    private activeProcedure(planId: number) {
      this.service.activateProcedure(planId).subscribe({
        next: data => { 
          if (data.status === "success"){
            this.filterList = true;
            this.getListProcedures(true, 1);
            this.snack.open(data.message, 'OK', { duration: 3000 });
          }
        },
      })
    }
  }
